import type { ReviewEntryTableRow } from '../types/reviewEntryTableRow'

export const getReviewEntriesOddDocumentRowIds = (rows: ReviewEntryTableRow[]): string[] => {
  const oddRowIds: string[] = []
  let lastEntryId: string | undefined
  let documentIndex = -1

  for (const row of rows) {
    if (row.entryId !== lastEntryId) {
      documentIndex += 1
      lastEntryId = row.entryId
    }

    if (documentIndex % 2 === 1) {
      oddRowIds.push(row.id)
    }
  }

  return oddRowIds
}
